export const TYPES = {
  SELECT_ALL_NOTES: "refund/SELECT_ALL_NOTES",
};
